export function formatComponentDemandNumber(value) {
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(value || 0);
}

export function formatComponentDemandUnits(value) {
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value || 0);
}

export function rowHasComponentDemandException(row) {
  return Boolean(row?.mismatch || row?.noDemand);
}

export function filterComponentDemandLedgerRows(
  rows,
  { search = '', exceptionsOnly = false, replacementOnly = false } = {}
) {
  const normalizedSearch = search.trim().toLowerCase();
  return (rows || []).filter(row => {
    const matchesSearch =
      !normalizedSearch ||
      String(row.supplySku || '').toLowerCase().includes(normalizedSearch) ||
      String(row.productName || '').toLowerCase().includes(normalizedSearch) ||
      String(row.subCategory || '').toLowerCase().includes(normalizedSearch);
    const hasException = rowHasComponentDemandException(row);
    return (
      matchesSearch &&
      (!exceptionsOnly || hasException) &&
      (!replacementOnly || Number(row.replacementDemand || 0) > 0)
    );
  });
}

export function summarizeComponentDemandLedgerRows(filteredRows) {
  const totalDirectDemand = filteredRows.reduce((sum, row) => sum + Number(row.directDemand || 0), 0);
  const totalBundleDemand = filteredRows.reduce(
    (sum, row) => sum + Number(row.bundleComponentDemand || 0),
    0
  );
  const totalReplacementDemand = filteredRows.reduce(
    (sum, row) => sum + Number(row.replacementDemand || 0),
    0
  );
  const totalSupplyDemand = filteredRows.reduce(
    (sum, row) => sum + Number(row.totalSupplyDemand || 0),
    0
  );
  const exceptionCount = filteredRows.filter(row => rowHasComponentDemandException(row)).length;

  return {
    supplySkuCount: filteredRows.length,
    totalDirectDemand,
    totalBundleDemand,
    totalReplacementDemand,
    totalSupplyDemand,
    exceptionCount,
  };
}

export function buildComponentDemandSubCategoryGroups(filteredRows) {
  const grouped = new Map();
  filteredRows.forEach(row => {
    const key = row.subCategory || 'Unassigned';
    const current = grouped.get(key);
    if (current) {
      current.skuCount += 1;
      current.totalSupplyDemand += Number(row.totalSupplyDemand || 0);
      current.replacementDemand += Number(row.replacementDemand || 0);
      return;
    }
    grouped.set(key, {
      subCategory: key,
      skuCount: 1,
      totalSupplyDemand: Number(row.totalSupplyDemand || 0),
      replacementDemand: Number(row.replacementDemand || 0),
    });
  });
  return Array.from(grouped.values()).sort(
    (left, right) =>
      right.totalSupplyDemand - left.totalSupplyDemand ||
      String(left.subCategory).localeCompare(String(right.subCategory))
  );
}
